/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Card,
  HStack,
  Heading,
  LinkButton,
  Spinner,
  Stack,
  Text,
} from '@mybridge/ui';
import {
  PlusIcon
} from '@mybridge/icons';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { DashboardPostBox } from 'v4/snippets/dashboard/feed/post-box';
import { MyProfileContext } from '../context';
import { MyProfileCreatePostModal } from '../create-post-modal';
import { DashboardPostForm } from 'v4/snippets/dashboard/post-form';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const MyProfileActivity = forwardRef(({ ...props }, ref) => {
  const {
    userProfileInfo,
    activityPosts,
    refetchActivityPosts,
    activityPostsHasNextPage,
    activityPostsFetchNextPage,
    activityDisc,
    activityPostsIsFetching,
    activityCount,
  } = useContext(MyProfileContext);
  const { profile_intro: intro } = userProfileInfo ?? {};
  const [showAll, setShowAll] = useState(true);
  const { t } = useTranslator();
  useEffect(() => {
    refetchActivityPosts?.();
  }, []);

  return (
    <>
      <Stack>
        {activityPosts?.length ? (
          <>
            {/* <HStack p={2}>
              <Stack flex={1}>
                <Heading size="md">Activity</Heading>
              </Stack>
              <HStack>
                <LinkButton onClick={(e) => activityDisc?.onOpen?.()}>
                  Create a post
                </LinkButton>
              </HStack>
            </HStack> */}
            <Card boxShadow="none" pl={0} p={[0, 3]}>
              <DashboardPostForm
                onCreateSuccess={(e) => {
                  refetchActivityPosts();
                }}
                fromProfile={true}
              />

              {/* <Stack>
                <Text fontWeight="bold">Your connections have missed you.</Text>
                <Text>Create a post so the networking can continue.</Text>
              </Stack> */}
            </Card>
            
            {showAll ? (
              <Stack spacing={4}>
                <InfiniteScroll
                  dataLength={activityCount}
                  next={activityPostsFetchNextPage}
                  hasMore={!!activityPostsHasNextPage}
                  loader={
                    <HStack p={4} justifyContent="center" w="100%">
                      <Spinner />
                    </HStack>
                  }
                // endMessage={
                //   <Text style={{ textAlign: 'center' }} py={3}>
                //     Yay! You have seen it all
                //   </Text>
                // }
                >
                  {activityPosts?.map((p, pIndex) => (
                    <Card boxShadow="none" key={pIndex} mb={4}>
                      <DashboardPostBox isInFrame={true} post={p} />
                    </Card>
                  ))}
                </InfiniteScroll>
                {/* {activityPostsHasNextPage ? (
                  <Button
                    onClick={(e) => activityPostsFetchNextPage?.()}
                    isLoading={activityPostsIsFetching}
                    variant="secondary"
                  >
                    Load More
                  </Button>
                ) : (
                  ''
                )} */}
              </Stack>
            ) : (
              <Card>
                <DashboardPostBox isInFrame={true} post={activityPosts?.[0]} />
                {activityPosts.length > 1 ? (
                  <Stack
                    borderTop="1px solid"
                    borderColor="brandGray.500"
                    p={4}
                  >
                    <HStack justifyContent="center">
                      <LinkButton
                        onClick={(e) => {
                          refetchActivityPosts?.();
                          setShowAll(true);
                        }}
                      >
                        {t('profileDetails.showMoreActivity') || 'Show more activity'}
                      </LinkButton>
                    </HStack>
                  </Stack>
                ) : (
                  ''
                )}
              </Card>
            )}
          </>
        ) : (
          <Card p={4} boxShadow="none"   sx={{
            '@media (max-width: 3100px)': {
              width:'100%'
            },
            '@media (max-width: 1040px)': {
              width:'100%'
            }
          }}>
            <Stack>
              <Stack spacing={1} alignItems='center' justifyContent="center">
                {/* <Text fontWeight="bold">{t('profileDetails.connectionsMissedYou') || 'Your connections have missed you.'}</Text>
                <Text>{t('profileDetails.createPostToContinue') || 'Create a post so the networking can continue.'}</Text> */}<Spinner/>
              </Stack>
            </Stack>
          </Card>
        )}
      </Stack>
      {activityDisc?.isOpen ? (
        <MyProfileCreatePostModal {...activityDisc} />
      ) : (
        ''
      )}
    </>
  );
});
